import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule } from "@app/core";
import { NgbAccordionModule, NgbDropdownModule, NgbNavModule, NgbProgressbarModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { CfsCommunicationPackModule } from "cfs-communication-pack";
import { SimplebarAngularModule } from "simplebar-angular";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LayoutsModule } from "./layouts/layouts.module";
import { ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER, AdvancedAccountSetupStatusApiProvider } from "./shared/components/advanced-account-setup-dialog";
import { SharedModule } from "./shared/shared.module";
import { UIModule } from "./shared/ui/ui.module";

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CoreModule.forRoot(),
    SharedModule,
    LayoutsModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgSelectModule,
    NgbProgressbarModule,
    SimplebarAngularModule,
    UIModule,
    BrowserAnimationsModule,
    CfsCommunicationPackModule.forRoot(environment.pubNubConfig)
  ],
  declarations: [AppComponent],
  providers: [{ provide: ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER, useExisting: AdvancedAccountSetupStatusApiProvider }],
  bootstrap: [AppComponent]
})
export class AppModule {}
